import React, { useState, useEffect } from 'react'
import { read, utils, writeFile } from 'xlsx';
import {
    useQuery,
    useQueryClient,
    useMutation
} from 'react-query'

import { sendToPrinter, updateSentToPrinter } from '../../../../api/apiServices';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import Pagination from '../../../../services/Pagination'

const LedgerBalances = () => {
    const queryClient = useQueryClient();

    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(15);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "pending_cards";

    const {
        isLoading,
        isError,
        error,
        data: cardsToPrinter
    } = useQuery('cardsToPrinter', sendToPrinter, {
        select: data => data.sort((a, b) => b.id - a.id),
    });


    let printerData = [];
    for (var i = 0; i < cardsToPrinter?.length; i++) {
        let printData = {
            serial_no: i + 1,
            pf_number: cardsToPrinter[i].pf_number,
            full_name: cardsToPrinter[i].first_name + " " + cardsToPrinter[i].middle_name + " " + cardsToPrinter[i].last_name,
            chapter: cardsToPrinter[i].chapter,
            region: cardsToPrinter[i].region,
            batch_number: cardsToPrinter[i].sent_batch_number
        }
        printerData.push(printData)
    }

    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPosts = printerData?.slice(indexOfFirstPage, indexOfLastPage);

    const updateCardMutation = useMutation(updateSentToPrinter, {
        onSuccess: () => {
            // Invalidate cached data
            queryClient.invalidateQueries("cardsToPrinter")
        }
    })

    let content

    if (isLoading) {
        content = <tr><td>Loading...</td></tr>
    } else if (isError) {
        content = <tr><td>{error.message}</td></tr>
    } else {
        content =
            currentPosts?.map((card, index) =>
                <tr key={card.id}>
                    <td style={{ textAlign: 'center' }} >{postPerPage * (currentPage - 1) + index + 1}</td>
                    <td>{card.pf_number}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{card.full_name}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{card.chapter}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{card.region}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{card.batch_number}</td>
                </tr>
            )
    }


    const handleExportExcel = () => {

        const headings = [[
            "Serial No",
            "PFNumber",
            "FullName",
            "Chapter",
            "Region",
            "Batch Number"
        ]];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, printerData, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Report');
        writeFile(wb, 'Proforum_Membership_Cards.xlsx');
        // updateCardMutation.mutate();
        navigate(from, { replace: true });
    }

    return (
        <><section className="content-header">
            <h1>Ledger Balances</h1>
        </section><section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    {/* <div className="col-sm-2">
                                        <h4 className="panel-title">
                                            <button onClick={handleExportExcel} className="btn btn-success btn-block"><i className='fa fa-file-text' aria-hidden="true"></i> Generate Excel File</button>&nbsp; &nbsp;
                                        </h4>
                                    </div>
                                    <div className="col-sm-2">
                                        <button className="btn btn-success btn-block">
                                            <i className="fa fa-file"></i> Generate PDF Report</button>
                                    </div> */}
                                </div>
                            </div>

                            <div className="panel-body">
                            </div>
                            <div className="panel-footer"></div>
                        </div>
                    </div>
                </div>
            </section></>
    )
}

export default LedgerBalances